export default {
  setSubscription: (state, payload) => {
    state.subscription = payload
  },
}
